import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class DocxTemplate extends AdornisFile {
  public static override _class = 'DocxTemplate';
  public static override _collectionName = 'docx-templates';

  @Field(type => String)
  @validate(nonOptional())
  public name!: string;
}
